import {IconButton, Menu, MenuItem} from "@mui/material"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import LoopIcon from "@mui/icons-material/Loop"
import styled, {keyframes} from "styled-components"
import React, {useState} from "react"

import {api} from "@indebted/api"
import {useAgent} from "@indebted/hooks/Agent"
import {useNotification} from "@indebted/components/Notification"
import {ConfirmationDialog} from "@indebted/components/ConfirmationDialog"

function PaymentPlanMenu({paymentPlanID, reload}: {paymentPlanID: string; reload: () => void}) {
	const [agentEmail] = useAgent()
	const {notification} = useNotification()
	const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined | null>()
	const [MenuIcon, setMenuIcon] = useState<React.ReactElement>(<MoreVertIcon />)
	const [confirmationDialogOpen, setConfirmationDialogOpen] = useState<boolean>(false)
	const [confirmationDialogOnOKFunc, setConfirmationDialogOnOKFunc] = useState<(() => void) | undefined>(undefined)
	const [confirmationDialogDescription, setConfirmationDialogDescription] = useState<string>("")

	const handleClick = (e: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(e.currentTarget)
	}

	const handleMenuClose = () => {
		setAnchorEl(null)
	}

	const handleMenuItemClick = () => {
		setMenuIcon(<LoadingIcon />)

		api.paymentPlan
			.cancel(paymentPlanID, {
				AgentEmail: agentEmail,
			})
			.then(() => {
				setMenuIcon(<MoreVertIcon />)
				notification.success(
					`Payment plan canceled successfully. Please wait up to 48 hours for propagation in all systems.`,
				)
				setTimeout(reload, 500)
			})
			.catch((error) => {
				setMenuIcon(<MoreVertIcon />)
				notification.error(error.Message)
			})

		handleMenuClose()
	}

	const confirmDialog = (description: string, onOK: () => void) => {
		handleMenuClose()
		setConfirmationDialogDescription(description)
		setConfirmationDialogOnOKFunc(() => onOK)
		setConfirmationDialogOpen(true)
	}

	return (
		<>
			<ConfirmationDialog
				description={confirmationDialogDescription}
				isOpen={confirmationDialogOpen}
				onCancel={() => {
					setConfirmationDialogOpen(false)
				}}
				onOK={() => {
					confirmationDialogOnOKFunc?.()
					setConfirmationDialogOpen(false)
				}}
			/>

			<IconButton size="small" onClick={handleClick}>
				{MenuIcon}
			</IconButton>
			<Menu
				anchorEl={anchorEl}
				open={Boolean(anchorEl)}
				anchorOrigin={{vertical: "bottom", horizontal: "right"}}
				transformOrigin={{vertical: "top", horizontal: "right"}}
				onClose={handleMenuClose}
			>
				<MenuItem
					onClick={() =>
						confirmDialog(`Payment plan will be canceled. Do you confirm?`, () => handleMenuItemClick())
					}
				>
					Cancel Payment Plan
				</MenuItem>
			</Menu>
		</>
	)
}

const loadingIconAnimations = keyframes`
	from { transform:rotate(0deg); }
    to { transform:rotate(-360deg);}
`

const LoadingIcon = styled(LoopIcon)`
	animation: ${loadingIconAnimations} 4s infinite linear;
`

export {PaymentPlanMenu}
